module.exports = __webpack_public_path__ + "img/light-and-low-pancakes.f9645015.jpg";